function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  d: "M1.18181818 8.99987793C.529118023 8.99987793 0 8.55216268 0 7.99987793 0 7.44759318.529118023 6.99987793 1.18181818 6.99987793L24.8181818 6.99987793C25.470882 6.99987793 26 7.44759318 26 7.99987793 26 8.55216268 25.470882 8.99987793 24.8181818 8.99987793L1.18181818 8.99987793zM1.18181818 2C.529118023 2 0 1.55228475 0 1 0 .44771525.529118023 0 1.18181818 0L24.8181818 0C25.470882 0 26 .44771525 26 1 26 1.55228475 25.470882 2 24.8181818 2L1.18181818 2z"
});

var SvgIconMenu = function SvgIconMenu(props) {
  return React.createElement("svg", _extends({
    width: 26,
    height: 9,
    viewBox: "0 0 26 9"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/icon-menu.b9b0db7c.svg";
export { SvgIconMenu as ReactComponent };